import ActionType from 'actions/ActionType'
import { REQUEST, SUCCESS, FAILURE } from 'utils/statusConstants'

export default (state = null, action) => {
  switch (action.type) {
    case ActionType.Data.LIST_REQUEST:
      if (action.entityType === 'inboxfilter') return REQUEST
      return state
    case ActionType.Data.LIST_SUCCESS:
      if (action.entityType === 'inboxfilter') return SUCCESS
      return state
    case ActionType.Data.LIST_FAILURE:
      if (action.entityType === 'inboxfilter') return FAILURE
      return state
    default:
      return state
  }
}
